(ns ui.utils
  (:require ["tailwind-merge" :refer [twMerge]]))

(defn reduce-classes [obj]
  (reduce
   (fn [acc [k v]]
     (if v
       (str acc " " k)
       acc))
   ""
   obj))

(defn clsx
  [& args]
  (reduce
   (fn [class v]
     (twMerge
      (str class " "
                   (cond (map? v)    (reduce-classes v)
                         (vector? v) (apply clsx v)
                         (string? v) v
                         (not v)     ""
                         :else       (do (js/console.error "Unknown type")
                                         v)))))
   ""
   args))

(defn separate-props [[props & children]]
  (let [children (or (:children props)
                     (some->> children
                              (filter identity)
                              (reduce (fn [acc item]
                                        (cond
                                          (seq? item) (concat acc item)
                                          :else (concat acc [item])))
                                      [])))]
    (if (map? props)
      [(dissoc props :children) (into [] children)]
      [nil (concat [props] children)])))
